/// <amd-module name="typeahead/core/presentation/DisplayGroupHandler" />

import {ISuggestionResult} from "typeahead/core/Suggestion";

interface IDisplayGroupItem {
    index: number;
    items: ISuggestionResult[];
    label: string;
}

export interface ISortedDisplayGroupItem {
    groupName: string;
    items: ISuggestionResult[];
    label: string;
}

export class DisplayGroupHandler {

    /**
     *
     * @param results
     * @returns {ISortedDisplayGroupItem[]}
     */
    public getResultsByDisplayGroup(results: any[]): ISortedDisplayGroupItem[] {
        let resultsByDisplayGroup = this.getDisplayGroupsPresent(results);
        $.each(results, (i, result) => {
            if (result.displayGroup) {
                // Push into the display group in the order in which the suggestions are received
                resultsByDisplayGroup[result.displayGroup.groupName].items.push(result);
            } else {
                resultsByDisplayGroup["default"].items.push(result);
            }
        });
        let sortedByDisplayOrder: ISortedDisplayGroupItem[] =
            this.sortDisplayGroupsByDisplayOrder(resultsByDisplayGroup);
        return sortedByDisplayOrder;
    }

    /**
     *
     * @param results
     * @returns {{[p: string]: IDisplayGroupItem}}
     */
    private getDisplayGroupsPresent(results: any[]): any {
        let resultsByDisplayGroup: { [name: string]: IDisplayGroupItem} = {};
        let that = this;
        $.each(results, (i, result) => {
            if (result.displayGroup) {
                // Push into the display group in the order in which the suggestions
                resultsByDisplayGroup[result.displayGroup.groupName] = {
                    index: Object.keys(resultsByDisplayGroup).length,
                    items: [],
                    label: result.displayGroup.label,
                };
            } else {
                // Push suggestions into "default" display group
                resultsByDisplayGroup["default"] = {
                    index: Object.keys(resultsByDisplayGroup).length,
                    items: [],
                    label: "",
                };
            }
        });
        //
        return resultsByDisplayGroup;
    }

    /**
     *
     * @param displayGroups
     * @returns {ISortedDisplayGroupItem[]}
     */
    private sortDisplayGroupsByDisplayOrder(displayGroups: { [name: string]: IDisplayGroupItem}):
      ISortedDisplayGroupItem[] {
        let keysSorted: any = Object.keys(displayGroups).sort( (a, b) => {
            return displayGroups[a].index - displayGroups[b].index;
        });

        let sortedDisplayGroups: ISortedDisplayGroupItem[] = [];
        keysSorted.forEach((key) => {
            sortedDisplayGroups.push({
                groupName: key,
                items: displayGroups[key].items,
                label: displayGroups[key].label,
            });
        });
        return sortedDisplayGroups;
    }
}
